import React from 'react';
import { AlertNotification, Grid } from '@arrow-ds/react';

const ErrorComponent = () => (
  <Grid container>
    <AlertNotification
      actionLabel=""
      notificationStyle="error"
      notificationType="in-page"
      showDismissButton={false}
    >
      Something went wrong. Please try again after some time.
    </AlertNotification>
  </Grid>
);

export default ErrorComponent;
